import DOMPurify from 'dompurify'

export const html_mixin = {
    methods: {
        html_sanitize(value) {
            return DOMPurify.sanitize(value)
        },
    },
}
